<template>
    <div class="box">
        <div class="top" style='background:url(../static/images/cs/e2809b0597463b3c879c0f44dded9a81.jpg);background-position-x: center; background-position-y: center;background-repeat: no-repeat;'>
        </div>
        <div class="center">
            <div class="text">
                <p class="title">
                    联系我们
                </p>
            </div>
            <div class="contactusList">

                <div class="contactusItem">
                    <img src="../images/gz.jpg" class="bg"/>
                    <h3>
                        广州总部
                    </h3>
                    <p>
                        <img src="../images/ic_home.png"/>
                        广东省白云区集贤路集安街3号, 凯云商务中心304室
                    </p>
                    <p>
                        <img src="../images/ic_phone.png"/>
                        15920931685
                    </p>
                    <p>
                        <img src="../images/ic_message.png"/>
                        duanyixiang@xingyunyi.cn
                    </p>
                </div>

                <div class="contactusItem">
                    <img src="../images/sz.jpg" class="bg"/>
                    <h3>
                        深圳分公司
                    </h3>
                    <p>
                        <img src="../images/ic_home.png"/>
                        广东省深圳市龙华区清湖路明腾中心大厦15楼1503B
                    </p>
                    <p>
                        <img src="../images/ic_phone.png"/>
                        18676373282
                    </p>
                    <p>
                        <img src="../images/ic_message.png"/>
                        tanronghui@xingyunyi.cn
                    </p>
                </div>

                <div class="contactusItem">
                    <img src="../images/cd.jpg" class="bg"/>
                    <h3>
                        郑州分公司
                    </h3>
                    <p>
                        <img src="../images/ic_home.png"/>
                        郑州市新郑市云港路与华夏大道世航之窗大厦B座907
                    </p>
                    <p>
                        <img src="../images/ic_phone.png"/>
                        15838346196
                    </p>
                    <p>
                        <img src="../images/ic_message.png"/>
                        mecoldfgo@xingyunyi.cn
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .top
    {
        width:100%;
        height: 200px;
    }

    .center{
        width:1300px;
        box-sizing: border-box;
        padding:50px 50px 100px 50px;
        min-height: 800px;
        background-color: #ffffff;
        border-radius: 5px;
        margin:0 auto;
        margin-top:-40px;
        color: #4b4b4b;
    }

     .text p{
        padding: 30px 0;
        padding-top:0;
        border-bottom: 1px solid #939393;
        margin: 0;
    }

    .text .title{
        font-weight: 800;
        font-size: 36px;
    }
    .contactusItem{
        margin-top: 20px;
    }
    .contactusItem{
        width:350px;
        float: left;
        height: 250px;
        margin-right: 25px;
    }
    .contactusItem .bg{
        width:349px;
        height: 131px;
        border-radius: 5px 5px 0 0;

    }
    .contactusItem h3{
        font-size: 18px;
        margin:  15px 0px;;
    }
    .contactusItem p{
        margin:  15px 0px;;
        vertical-align: middle;
        font-size: 12px;
    }
    .contactusItem img{
        margin-right: 10px;
        vertical-align: middle;
    }

</style>
<script>
export default {
  data () {
    return {
      dto: {}
    }
  },
  name: 'ContactUS',
  created () {
    // this.dto.Name = this.$route.params.name;
    // this.dto.Src = '/static/images/cs/3b0f95d6ed6a48e6b04cc9862ea226b4.jpg'
    // this.dto.Type = '专线服务';
    // this.dto.Code = 'USLine-6';
    // this.dto.Efficiency = '10-15工作日';
    // this.dto.MaxWeight = '30';
    // this.dto.MaxWidth = '60';
    // this.dto.MaxLength = '40';
    // this.dto.MaxHeight = '35';
    // this.dto.BillingDescription = '包裹实际重量和体积重量相比，取较大者计算（体积重量计算方式为:长*宽*高cm/8000=KG)；';
    // this.dto.GoodsLimit='不接受任何侵权产品、纯电、液体、粉末、危险品、枪支弹药等违禁品';
    // this.dto.DeclareDemand='我司不接受申报价值超过800美金的货物；且不接受同一个收件人名且同一地址，当天累计包裹申报价值超过800美金。';
    // this.dto.DeliveryRange = '全美，不包括阿拉斯加、夏威夷等偏远地区，波多黎各、关岛等境外地址；APO/FPO军事地址。';
    // this.dto.PackingDemand = '不接收圆柱形、不规则包装，标签需平整地贴在包裹的最大面。';

  }

}
</script>



// WEBPACK FOOTER //
// src/components/contactus.vue